import router from '../../router'
import constant from '../constant'

import {
  LOGIN, LOGIN_SUCCESS, LOGIN_FAILURE, LOGOUT, AUTHORIZE, AUTHORIZE_SUCCESS, AUTHORIZE_FAILURE,
  CHANGE_PASSWORD, CHANGE_PASSWORD_SUCCESS, CHANGE_PASSWORD_FAILURE, CLEAR_AUTH_STATUS, CANNOT_USE,
  PASSWORD_RESET_MAIL_SEND, PASSWORD_RESET_MAIL_SEND_SUCCESS, PASSWORD_RESET_MAIL_SEND_FAILURE,
  PASSWORD_RESET_UPDATE, PASSWORD_RESET_UPDATE_SUCCESS, PASSWORD_RESET_UPDATE_FAILURE
} from './mutation-types'

export default {
  state: {
    user: {
      userId: null,
      userType: null,
      shopId: null,
      loginId: null,
      name: null,
      error: '',
      status: null,
      keepLogin: true,
      userAuthority: null,
      shopMaster: 0,
      shopManager: 0,
      harassment: 0
    },
    constant: constant
  },
  getters: {
    authStatus: state => {
      return state.user !== null ? state.user.status : null
    },
    authError: state => {
      return state.user !== null ? state.user.error : null
    },
    isLogin: state => {
      return state.user !== null && state.user.userId !== null
    },
    userLoginId: state => {
      return state.user.loginId
    },
    userName: state => {
      return state.user.name
    },
    userShopId: state => {
      return state.user.shopId
    },
    userAuthority: state => {
      return state.user.userAuthority
    },
    shopMaster: state => {
      return state.user.shopMaster
    },
    shopManager: state => {
      return state.user.shopManager
    },
    harassment: state => {
      return state.user.harassment
    }
  },
  actions: {
    [LOGIN] ({dispatch, state, commit}, params) {
      state.user.keepLogin = params.keepLogin
      var callback = null
      if (params.callback) {
        callback = params.callback
      }
      dispatch('apiPost', {url: '/login', data: params.data})
      .then(res => {
        if (res.status === 200) {
          if (res.data.error) {
            commit(LOGIN_FAILURE, res.data)
          } else {
            res.data.callback = callback
            commit(LOGIN_SUCCESS, res.data)
          }
        }
        return Promise.resolve(res.data)
      })
      .catch(error => {
        throw error
      })
    },
    [CHANGE_PASSWORD] ({dispatch, state, commit}, params) {
      state.user.status = null
      dispatch('apiPatch', {url: '/account_update', data: params.data})
      .then(res => {
        if (res.status === 200) {
          if (res.data.error) {
            commit(CHANGE_PASSWORD_FAILURE, res.data)
          } else {
            commit(CHANGE_PASSWORD_SUCCESS, res.data)
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    [AUTHORIZE] ({dispatch, state, commit}, params) {
      if (window.localStorage.getItem('keep_limit') && parseInt(window.localStorage.getItem('keep_limit')) !== 0) {
        var date = new Date()
        var now = date.getTime()

        if (now > parseInt(window.localStorage.getItem('keep_limit'))) {
          commit(LOGOUT)
        } else {
          var keepLimit = date.getTime() + constant.keepLimit
          window.localStorage.setItem('keep_limit', keepLimit)
        }
      }
      var callback = () => {}
      if (params) {
        if ('callback' in params) {
          callback = params.callback
        }
      }
      dispatch('apiGet', {url: '/login/current_user_info'})
      .then(res => {
        if (res.status === 200) {
          if (res.data.error) {
            commit(AUTHORIZE_FAILURE, res.data)
          } else {
            commit(AUTHORIZE_SUCCESS, {data: res.data, callback: callback})
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    [LOGOUT] ({ commit }) {
      commit(LOGOUT)
    },
    [CLEAR_AUTH_STATUS] ({ state }) {
      state.user.error = ''
      state.user.status = null
    },
    [CANNOT_USE]  ({ commit }) {
      commit(CANNOT_USE)
    },
    [PASSWORD_RESET_MAIL_SEND] ({dispatch, state, commit}, params) {
      return new Promise((resolve, reject) => {
        state.user.status = null
        dispatch('apiPost', {url: '/reset_password/send_mail', data: params.data, loadparams: 'block'})
        .then(res => {
          if (res.status === 200) {
            if (res.data.error) {
              commit(PASSWORD_RESET_MAIL_SEND_FAILURE, res.data)
              reject()
            } else {
              commit(PASSWORD_RESET_MAIL_SEND_SUCCESS, res.data)
              resolve()
            }
          }
        })
        .catch(error => {
          throw error
        })
      })
    },
    [PASSWORD_RESET_UPDATE] ({dispatch, state, commit}, params) {
      return new Promise((resolve, reject) => {
        state.user.status = null
        dispatch('apiPost', {url: '/reset_password/reset', data: params.data, loadparams: 'block'})
        .then(res => {
          if (res.status === 200) {
            if (res.data.error) {
              commit(PASSWORD_RESET_UPDATE_FAILURE, res.data)
              reject()
            } else {
              commit(PASSWORD_RESET_UPDATE_SUCCESS, res.data)
              resolve()
            }
          }
        })
        .catch(error => {
          throw error
        })
      })
    }
  },
  mutations: {
    [LOGIN_FAILURE] (state, data) {
      state.user.error = data.error
    },
    [LOGIN_SUCCESS] (state, data) {
      state.user.error = ''
      state.user.userId = data.data.id
      state.user.shopId = data.data.attributes['shop-id']
      state.user.loginId = data.data.attributes['login-id']
      state.user.name = data.data.attributes['user-name'] + ' ' + data.data.attributes['user-firstname']
      state.user.userAuthority = data.data.attributes['user-authority']
      state.user.shopMaster = data.data.attributes['is-shop-master']
      state.user.shopManager = data.data.attributes['is-shop-manager']
      state.user.harassment = data.data.attributes['is-harassment']
      window.localStorage.setItem('user_id', data.data.id)
      window.localStorage.setItem('access_token', data.data.attributes['asovi-access-token'])
      window.localStorage.setItem('user_authority', data.data.attributes['user-authority'])
      window.localStorage.setItem('is_shop_master', data.data.attributes['is-shop-master'])
      window.localStorage.setItem('is_shop_manager', data.data.attributes['is-shop-manager'])
      window.localStorage.setItem('is_harassment', data.data.attributes['is-harassment'])
      window.localStorage.setItem('shop_id', data.data.attributes['shop-id'])
      window.localStorage.setItem('profile_image_path', data.data.attributes['profile-image-path'])
      window.localStorage.setItem('user_name', state.user.name)
      window.localStorage.setItem('is_clerk', data.data.attributes['is-clerk'])
      var keepLimit = 0
      if (!state.user.keepLogin) {
        var date = new Date()
        keepLimit = date.getTime() + constant.keepLimit
      }
      window.localStorage.setItem('keep_limit', keepLimit)
      var isOfficer = 0
      for (var i in state.constant.officerUserIds) {
        if (Number(data.data.id) === state.constant.officerUserIds[i]) {
          isOfficer = 1
          break
        }
      }
      window.localStorage.setItem('is_officer', isOfficer)

      if (data.callback) {
        data.callback()
      }
    },
    [CHANGE_PASSWORD_FAILURE] (state, data) {
      state.user.error = data.error
      state.user.status = 'error'
    },
    [CHANGE_PASSWORD_SUCCESS] (state, data) {
      state.user.status = 'success'
    },
    [AUTHORIZE_FAILURE] (state, data) {
      state.user.error = data.error
      router.push('/login')
    },
    [AUTHORIZE_SUCCESS] (state, params) {
      var data = params.data
      state.user.userId = data.data.id
      state.user.shopId = data.data.attributes['shop-id']
      state.user.loginId = data.data.attributes['login-id']
      state.user.name = data.data.attributes['user-name'] + ' ' + data.data.attributes['user-firstname']
      state.user.userAuthority = data.data.attributes['user-authority']
      state.user.shopMaster = data.data.attributes['is-shop-master']
      state.user.shopManager = data.data.attributes['is-shop-manager']
      state.user.harassment = data.data.attributes['is-harassment']
      window.localStorage.setItem('user_id', data.data.id)
      window.localStorage.setItem('access_token', data.data.attributes['asovi-access-token'])
      window.localStorage.setItem('user_authority', data.data.attributes['user-authority'])
      window.localStorage.setItem('is_shop_master', data.data.attributes['is-shop-master'])
      window.localStorage.setItem('is_shop_manager', data.data.attributes['is-shop-manager'])
      window.localStorage.setItem('is_harassment', data.data.attributes['is-harassment'])
      window.localStorage.setItem('shop_id', data.data.attributes['shop-id'])
      window.localStorage.setItem('profile_image_path', data.data.attributes['profile-image-path'])
      window.localStorage.setItem('user_name', state.user.name)
      window.localStorage.setItem('is_clerk', data.data.attributes['is-clerk'])
      var isOfficer = 0
      for (var i in state.constant.officerUserIds) {
        if (Number(data.data.id) === state.constant.officerUserIds[i]) {
          isOfficer = 1
          break
        }
      }
      window.localStorage.setItem('is_officer', isOfficer)
      if (params.callback) {
        params.callback()
      }
    },
    [LOGOUT] (state) {
      state = null
      window.localStorage.clear()
      router.push('/login')
    },
    [CANNOT_USE] (state) {
      router.push('/')
    },
    [PASSWORD_RESET_MAIL_SEND_FAILURE] (state, data) {
      state.user.error = data.error
      state.user.status = 'error'
    },
    [PASSWORD_RESET_MAIL_SEND_SUCCESS] (state, {data, params}) {
      state.user.status = 'success'
    },
    [PASSWORD_RESET_UPDATE_FAILURE] (state, data) {
      state.user.error = data.error
      state.user.status = 'error'
    },
    [PASSWORD_RESET_UPDATE_SUCCESS] (state, {data, params}) {
      state.user.status = 'success'
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/auth.js